<template>
  <div>
    <div class="row" v-if="showHeader">
      <h6 class="heading-small text-muted mb-4 pl-2">
        <i class="fas fa-search"></i> Informações adicionais
      </h6>
    </div>
    <div class="row" v-if="formatted">
      <div
        :class="[size, 'mb-3 d-flex align-items-stretch']"
        v-for="card in data"
        :key="'card_' + card.id"
      >
        <card
          type="white"
          header-classes="bg-transparent py-2 px-3"
          :body-classes="[
            card.type === 'pie_chart' ? 'pb-2' : 'pb-0',
            'px-0 pt-0 d-flex',
          ]"
          class="flex-grow-1"
        >
          <div slot="header" class="row align-items-center">
            <div class="col-12">
              <h5 class="h3 mb-0">
                {{ card.title }}
                <router-link
                  v-if="showEditLink"
                  :to="`/admin/batches/${card.batch_id}/acompanhamento/startups/${card.startup_id}/cards/${card.id}/editar`"
                >
                  <i class="ml-1 fas fa-eye text-sm"></i>
                </router-link>
              </h5>
              <h6 class="text-muted text-uppercase ls-1 mb-1">
                {{ card.subtitle }}
              </h6>
            </div>
          </div>
          <div class="col-12 align-self-center p-0">
            <div
              v-if="card.type === 'text'"
              class="cc-container-read-only small"
            >
              <quill-editor
                v-model="card.text_data"
                :options="editorReadOnly"
                disabled="disabled"
              >
              </quill-editor>
            </div>
            <apexchart
              v-else
              :height="height"
              :options="card.chartOptions"
              :series="card.chartSeries"
            ></apexchart>
          </div>
        </card>
      </div>
    </div>
  </div>
</template>
<script>
import VueApexCharts from "vue-apexcharts";

import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

import { quillEditor } from "vue-quill-editor";

export default {
  name: "custom-card-list",
  components: {
    apexchart: VueApexCharts,
    quillEditor,
  },
  props: {
    data: {
      type: Array,
      default: () => [],
      description: "Cards list",
    },
    showHeader: {
      type: Boolean,
      default: true,
      description: "Should show card header",
    },
    size: {
      type: String,
      default: "col-lg-4",
      description: "Card list sizes",
    },
    height: {
      type: Number,
      default: 240,
      description: "Chart height",
    },
    showEditLink: {
      type: Boolean,
      default: false,
      description: "Should show edit link",
    },
  },
  data() {
    return {
      editorReadOnly: {
        placeholder: "N/A",
        readOnly: true,
        theme: "bubble",
      },
      formatted: false,
    };
  },
  mounted() {
    this.handleNewData();
  },
  methods: {
    handleNewData() {
      const cards = this.data;
      for (const card of cards) {
        if (card.type === "line_chart") this.formatLineChartData(card);
        else if (card.type === "pie_chart") this.formatPieChartData(card);
        this.formatted = true;
      }
    },
    formatLineChartData(card) {
      const points = JSON.parse(card.chart_data);
      const series = {
        name: card.title,
        data: [],
      };
      const options = {
        legend: {
          position: "bottom",
        },
        chart: {
          type: "line",

          toolbar: {
            show: true,
            zoom: {
              enabled: true,
            },
            tools: {
              download: true,
              selection: true,
              zoom: true,
              zoomin: true,
              zoomout: true,
              pan: true,
              reset: true,
            },
            autoSelected: "zoom",
          },
        },
        stroke: {
          curve: "smooth",
        },
        xaxis: {
          categories: [],
        },
        yaxis: {
          forceNiceScale: true,
          labels: {
            formatter: function (val) {
              return Math.round(val * 100) / 100;
            },
          },
        },
      };
      points.forEach((point) => {
        series.data.push(Number(point.data));
        options.xaxis.categories.push(point.label);
      });
      card.chartSeries = [series];
      card.chartOptions = options;
    },
    formatPieChartData(card) {
      const points = JSON.parse(card.chart_data);
      const series = [];
      const options = {
        legend: {
          position: "bottom",
        },
        chart: {
          type: "pie",
          toolbar: {
            show: true,
            tools: {
              download: true,
            },
            autoSelected: "zoom",
          },
        },
        labels: [],
      };
      points.forEach((point) => {
        series.push(Number(point.data));
        options.labels.push(point.label);
      });
      card.chartSeries = series;
      card.chartOptions = options;
    },
  },
  watch: {
    data: function () {
      this.handleNewData();
    },
  },
};
</script>
<style>
p > strong {
  font-weight: bold !important;
}

.cc-container-read-only .quill-editor .ql-container,
.cc-container-read-only .quill-editor .ql-container .ql-editor {
  max-height: 240px;
  width: 100%;
}
</style>
